import PropTypes from 'prop-types';
import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = buildUseStyles('MeetingHeader', (theme) => ({
  root: {
    paddingRight: theme.spacing(2),
  },
  eventChip: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0, 1),
    maxWidth: '100%',
  },
}));

const MeetingEventMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  useComponentDidMount(() => {
    onLoadComplete();
  });


  return (
    <Box className={classes.root}>
      <Chip
        size="medium"
        label={messageResource.attr('content')}
        className={classes.eventChip}
      />
    </Box>
  );
};

MeetingEventMessageContent.defaultProps = {
  onLoadComplete: noop,
};

MeetingEventMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default MeetingEventMessageContent;
